import RemoteStore from '../lib/util/remote-store';

class SettingsService {
	async getStore() {
		return new RemoteStore('settings');
	}

	async get() {
		const store = await this.getStore();
		if (store) return store.get();
	}

	async set(settings) {
		const store = await this.getStore();
		if (store) return store.save(settings);
	}
}

export default new SettingsService();
